import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: any;
};

export type ChangePasswordInput = {
  newPassword: Scalars['String'];
  oldPassword: Scalars['String'];
};

export type Comments = {
  __typename?: 'Comments';
  _id: Scalars['String'];
  comment: Scalars['String'];
  commentedAt: Scalars['DateTime'];
  commentedBy: User;
};

export type CommonUserOutput = {
  __typename?: 'CommonUserOutput';
  _id: Scalars['String'];
  avatar?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  email: Scalars['String'];
  name: Scalars['String'];
  role: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type CreateCommentInput = {
  comment: Scalars['String'];
  docStackId: Scalars['String'];
};

export type CreateDocumentInput = {
  label: Scalars['String'];
  remark?: InputMaybe<Scalars['String']>;
  url: Scalars['String'];
};

export type CreateEcmUser = {
  GCPCertificate: Array<Scalars['String']>;
  avatar?: InputMaybe<Scalars['String']>;
  cv: Scalars['String'];
  dateOFTenureCompletion: Scalars['DateTime'];
  dateOfAppointment: Scalars['DateTime'];
  dateOfCertification: Scalars['DateTime'];
  dateOfResignation: Scalars['DateTime'];
  email?: InputMaybe<Scalars['String']>;
  isAffiliatedToMedanta: Scalars['Boolean'];
  medicalRegistrationCertificate: Scalars['String'];
  memberType: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  nextGCPCertificateDueOn: Scalars['DateTime'];
  password?: InputMaybe<Scalars['String']>;
  qualification: Array<Scalars['String']>;
  reasonForResignation: Scalars['String'];
  resignLetter: Scalars['String'];
  role?: InputMaybe<Scalars['String']>;
  rolesInEC: Scalars['String'];
  signedConfidentialityAgreement: Scalars['String'];
  signedConflictOfInterest: Scalars['String'];
  trainings: Array<Tranings>;
  validUpto: Scalars['DateTime'];
};

export type CreateEcSubmissionInput = {
  documents: Array<CreateDocumentInput>;
  studyDetails: StudyDetailsInput;
  sub_type?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
};

export type CreateIrbInput = {
  IRBPresentation: Scalars['String'];
  dateOfIRBSubmission: Scalars['DateTime'];
  department: Scalars['String'];
  documents: Array<CreateDocumentInput>;
  emails: Array<Scalars['String']>;
  fundType: Scalars['String'];
  isFunded: Scalars['Boolean'];
  micr?: InputMaybe<Scalars['String']>;
  principalInvestigator: Scalars['String'];
  protocolNumber: Scalars['String'];
  sponsor: Scalars['String'];
  studyPhase: Scalars['String'];
  title: Scalars['String'];
  type: Scalars['String'];
  typeOfStudy: Scalars['String'];
};

export type CreateUserInput = {
  avatar: Scalars['String'];
  email: Scalars['String'];
  name: Scalars['String'];
  password: Scalars['String'];
  role: Scalars['String'];
};

export type DocStack = {
  __typename?: 'DocStack';
  _id: Scalars['String'];
  comments?: Maybe<Array<Comments>>;
  createdAt: Scalars['DateTime'];
  doc: Documents;
  readAndAcknowledge: Scalars['Boolean'];
  remark?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  url: Scalars['String'];
};

export type Documents = {
  __typename?: 'Documents';
  _id: Scalars['String'];
  docStack: Array<DocStack>;
  isReadAndAcknowledged: Scalars['Boolean'];
  label: Scalars['String'];
};

export type DocumentsOutput = {
  __typename?: 'DocumentsOutput';
  _id?: Maybe<Scalars['String']>;
  isReadAndAcknowledged: Scalars['Boolean'];
  label?: Maybe<Scalars['String']>;
};

export type DropdownListOutput = {
  __typename?: 'DropdownListOutput';
  coInvestigator: Array<Scalars['String']>;
  department: Array<Scalars['String']>;
  principalInvestigator: Array<Scalars['String']>;
  sponsor: Array<Scalars['String']>;
};

export type EcSubmissionOutput = {
  __typename?: 'ECSubmissionOutput';
  _id: Scalars['String'];
  createdAt: Scalars['DateTime'];
  createdBy: CommonUserOutput;
  documents?: Maybe<Array<DocumentsOutput>>;
  isAllDocReadAndAcknowledged: Scalars['Boolean'];
  studyDetails: StudyDetailsOutput;
  sub_type?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type EcSubmissionsOutput = {
  __typename?: 'ECSubmissionsOutput';
  ecs: Array<EcSubmissionOutput>;
  totalCount: Scalars['Int'];
};

export type Irb = {
  __typename?: 'Irb';
  IRBPresentation: Scalars['String'];
  _id: Scalars['String'];
  createdBy: User;
  dateOfIRBSubmission: Scalars['DateTime'];
  department: Scalars['String'];
  documents: Array<Documents>;
  emails: Array<Scalars['String']>;
  fundType: Scalars['String'];
  isAllDocReadAndAcknowledged: Scalars['Boolean'];
  isFunded: Scalars['Boolean'];
  micr: Scalars['String'];
  principalInvestigator: Scalars['String'];
  protocolNumber: Scalars['String'];
  sponsor: Scalars['String'];
  studyPhase: Scalars['String'];
  title: Scalars['String'];
  type: Scalars['String'];
  typeOfStudy: Scalars['String'];
};

export type IrbOutput = {
  __typename?: 'IrbOutput';
  IRBPresentation: Scalars['String'];
  _id: Scalars['String'];
  createdAt: Scalars['DateTime'];
  createdBy: CommonUserOutput;
  dateOfIRBSubmission: Scalars['DateTime'];
  department: Scalars['String'];
  documents?: Maybe<Array<DocumentsOutput>>;
  emails: Array<Scalars['String']>;
  fundType: Scalars['String'];
  isAllDocReadAndAcknowledged: Scalars['Boolean'];
  isFunded: Scalars['Boolean'];
  micr?: Maybe<Scalars['String']>;
  principalInvestigator: Scalars['String'];
  protocolNumber: Scalars['String'];
  sponsor: Scalars['String'];
  studyPhase: Scalars['String'];
  title: Scalars['String'];
  type: Scalars['String'];
  typeOfStudy: Scalars['String'];
};

export type IrbsOutput = {
  __typename?: 'IrbsOutput';
  irbs: Array<IrbOutput>;
  totalCount: Scalars['Int'];
};

export type Meeting = {
  __typename?: 'Meeting';
  _id: Scalars['String'];
  agenda: Scalars['String'];
  createdAt: Scalars['DateTime'];
  lastSubmissionDate: Scalars['DateTime'];
  meetingDate: Scalars['DateTime'];
  meetingId: Scalars['String'];
  meetingType: Scalars['String'];
  mom: Scalars['String'];
  projects: Array<Project>;
  updatedAt: Scalars['DateTime'];
};

export type MeetingInput = {
  agenda: Scalars['String'];
  lastSubmissionDate: Scalars['DateTime'];
  meetingDate: Scalars['DateTime'];
  meetingId: Scalars['String'];
  meetingType: Scalars['String'];
};

export type MeetingOutput = {
  __typename?: 'MeetingOutput';
  meetings: Array<Meeting>;
  totalCount: Scalars['Int'];
};

export type MeetingSingleOutput = {
  __typename?: 'MeetingSingleOutput';
  _id: Scalars['String'];
  agenda: Scalars['String'];
  createdAt: Scalars['DateTime'];
  lastSubmissionDate: Scalars['DateTime'];
  meetingDate: Scalars['DateTime'];
  meetingId: Scalars['String'];
  meetingType?: Maybe<Scalars['String']>;
  mom?: Maybe<Scalars['String']>;
  projects?: Maybe<Array<ProjectOutput>>;
  updatedAt: Scalars['DateTime'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addComment: DocStack;
  changePassword: CommonUserOutput;
  createECMUser: UserEcmOutput;
  createECS: EcSubmissionOutput;
  createIrb: IrbOutput;
  createMeeting: Meeting;
  createUser: User;
  reUploadDoc: DocStack;
  readAndAcknowledge: DocStack;
  removeECS: EcSubmissionOutput;
  removeIrb: IrbOutput;
  removeMeeting: Meeting;
  removeUser: User;
  signin: SigninOutput;
  updateECM: UserEcmOutput;
  updateECS: EcSubmissionOutput;
  updateIrb: IrbOutput;
  updateMeeting: Meeting;
  updateRoleInEC: UserEcmOutput;
  updateUser: UserEcmOutput;
};


export type MutationAddCommentArgs = {
  createCommentInput: CreateCommentInput;
};


export type MutationChangePasswordArgs = {
  changePasswordInput: ChangePasswordInput;
};


export type MutationCreateEcmUserArgs = {
  createECMUser: CreateEcmUser;
};


export type MutationCreateEcsArgs = {
  createECSubmissionInput: CreateEcSubmissionInput;
};


export type MutationCreateIrbArgs = {
  createIrbInput: CreateIrbInput;
};


export type MutationCreateMeetingArgs = {
  createMeetingInput: MeetingInput;
};


export type MutationCreateUserArgs = {
  createUserInput: CreateUserInput;
};


export type MutationReUploadDocArgs = {
  reUploadDocInput: ReUploadDocInput;
};


export type MutationReadAndAcknowledgeArgs = {
  readAndAcknowledgeInput: ReadAndAcknowledgeInput;
};


export type MutationRemoveEcsArgs = {
  _id: Scalars['String'];
};


export type MutationRemoveIrbArgs = {
  _id: Scalars['String'];
};


export type MutationRemoveMeetingArgs = {
  _id: Scalars['String'];
};


export type MutationRemoveUserArgs = {
  _id: Scalars['String'];
};


export type MutationSigninArgs = {
  signinInput: SigninInput;
};


export type MutationUpdateEcmArgs = {
  updateECMUserInput: UpdateEcmUserInput;
};


export type MutationUpdateEcsArgs = {
  updateECSubmissionInput: UpdateEcSubmissionInput;
};


export type MutationUpdateIrbArgs = {
  updateIrbInput: UpdateIrbInput;
};


export type MutationUpdateMeetingArgs = {
  updateMeetingInput: UpdateMeetingInput;
};


export type MutationUpdateRoleInEcArgs = {
  roleInEC: RoleInEc;
};


export type MutationUpdateUserArgs = {
  updateUserInput: UpdateUserInput;
};

export type Project = {
  __typename?: 'Project';
  _id: Irb;
  documents?: Maybe<Array<MeetingDoc>>;
};

export type ProjectInput = {
  _id: Scalars['String'];
  documents: Array<MeetingDocInput>;
};

export type ProjectOutput = {
  __typename?: 'ProjectOutput';
  _id: Irb;
  documents: Array<MeetingDoc>;
};

export type ProtocolsOutput = {
  __typename?: 'ProtocolsOutput';
  _id: Scalars['String'];
  protocolNumber: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  ecSubmission: EcSubmissionOutput;
  findAllDocStack: Array<DocStack>;
  findOneMeeting: MeetingSingleOutput;
  getAllECSubmissions: EcSubmissionsOutput;
  getAllIRBSubmissions: IrbsOutput;
  getAllMeetings: MeetingOutput;
  getAllUser: UsersEcmOutput;
  getComments: Scalars['String'];
  getProtocolList: Array<ProtocolsOutput>;
  getSubmissionDropdownList: DropdownListOutput;
  getUserById: UserEcmOutput;
  irb: IrbOutput;
};


export type QueryEcSubmissionArgs = {
  id: Scalars['String'];
};


export type QueryFindAllDocStackArgs = {
  docId: Scalars['String'];
};


export type QueryFindOneMeetingArgs = {
  _id: Scalars['String'];
};


export type QueryGetAllEcSubmissionsArgs = {
  keyword?: InputMaybe<Scalars['String']>;
  page: Scalars['Int'];
  perPage: Scalars['Int'];
};


export type QueryGetAllIrbSubmissionsArgs = {
  keyword?: InputMaybe<Scalars['String']>;
  page: Scalars['Int'];
  perPage: Scalars['Int'];
  type: Scalars['String'];
};


export type QueryGetAllMeetingsArgs = {
  meetingDate?: InputMaybe<Scalars['String']>;
  meetingType?: InputMaybe<Scalars['String']>;
  page: Scalars['Int'];
  perPage: Scalars['Int'];
};


export type QueryGetAllUserArgs = {
  keyword?: InputMaybe<Scalars['String']>;
  page: Scalars['Int'];
  perPage: Scalars['Int'];
  role?: InputMaybe<Scalars['String']>;
};


export type QueryGetCommentsArgs = {
  docId: Scalars['String'];
  subType: Scalars['String'];
  submissionType: Scalars['String'];
};


export type QueryGetProtocolListArgs = {
  subType: Scalars['String'];
  submissionType: Scalars['String'];
};


export type QueryGetUserByIdArgs = {
  _id: Scalars['String'];
};


export type QueryIrbArgs = {
  id: Scalars['String'];
};

export type ReUploadDocInput = {
  docId: Scalars['String'];
  fileUrl: Scalars['String'];
  submissionId: Scalars['String'];
  submissionType: Scalars['String'];
};

export type RoleInEc = {
  _id: Scalars['String'];
  role: Scalars['String'];
  rolesInEC: Scalars['String'];
};

export type SigninInput = {
  email: Scalars['String'];
  password: Scalars['String'];
};

export type SigninOutput = {
  __typename?: 'SigninOutput';
  /** Generated token of the user */
  token: Scalars['String'];
  /** user information */
  user: User;
};

export type StudyDetailsInput = {
  coInvestigator: Scalars['String'];
  dateOfEvent?: InputMaybe<Scalars['DateTime']>;
  department: Scalars['String'];
  emails: Array<Scalars['String']>;
  fundType?: InputMaybe<Scalars['String']>;
  isFunded: Scalars['Boolean'];
  micr: Scalars['String'];
  principalInvestigator: Scalars['String'];
  protocolNumber: Scalars['String'];
  sponsor: Scalars['String'];
  studyPhase: Scalars['String'];
  title: Scalars['String'];
  typeOfPVPD?: InputMaybe<Scalars['String']>;
  typeOfStudy?: InputMaybe<Scalars['String']>;
};

export type StudyDetailsOutput = {
  __typename?: 'StudyDetailsOutput';
  coInvestigator: Scalars['String'];
  dateOfEvent?: Maybe<Scalars['DateTime']>;
  department: Scalars['String'];
  emails: Array<Scalars['String']>;
  fundType?: Maybe<Scalars['String']>;
  isFunded: Scalars['Boolean'];
  micr?: Maybe<Scalars['String']>;
  principalInvestigator: Scalars['String'];
  protocolNumber: Scalars['String'];
  sponsor: Scalars['String'];
  studyPhase: Scalars['String'];
  title: Scalars['String'];
  typeOfPVPD?: Maybe<Scalars['String']>;
  typeOfStudy?: Maybe<Scalars['String']>;
};

export type Tranings = {
  date: Scalars['DateTime'];
  name: Scalars['String'];
  url: Scalars['String'];
};

export type TraningsOutput = {
  __typename?: 'TraningsOutput';
  date: Scalars['DateTime'];
  name: Scalars['String'];
  url: Scalars['String'];
};

export type UpdateEcmUserInput = {
  GCPCertificate?: InputMaybe<Array<Scalars['String']>>;
  _id: Scalars['String'];
  avatar?: InputMaybe<Scalars['String']>;
  cv?: InputMaybe<Scalars['String']>;
  dateOFTenureCompletion?: InputMaybe<Scalars['DateTime']>;
  dateOfAppointment?: InputMaybe<Scalars['DateTime']>;
  dateOfCertification?: InputMaybe<Scalars['DateTime']>;
  dateOfResignation?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  isAffiliatedToMedanta?: InputMaybe<Scalars['Boolean']>;
  medicalRegistrationCertificate?: InputMaybe<Scalars['String']>;
  memberType?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nextGCPCertificateDueOn?: InputMaybe<Scalars['DateTime']>;
  password?: InputMaybe<Scalars['String']>;
  qualification?: InputMaybe<Array<Scalars['String']>>;
  reasonForResignation?: InputMaybe<Scalars['String']>;
  resignLetter?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['String']>;
  rolesInEC?: InputMaybe<Scalars['String']>;
  signedConfidentialityAgreement?: InputMaybe<Scalars['String']>;
  signedConflictOfInterest?: InputMaybe<Scalars['String']>;
  trainings?: InputMaybe<Array<Tranings>>;
  validUpto?: InputMaybe<Scalars['DateTime']>;
};

export type UpdateEcSubmissionInput = {
  documents?: InputMaybe<Array<CreateDocumentInput>>;
  id: Scalars['String'];
  studyDetails?: InputMaybe<StudyDetailsInput>;
  sub_type?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type UpdateIrbInput = {
  IRBPresentation?: InputMaybe<Scalars['String']>;
  dateOfIRBSubmission?: InputMaybe<Scalars['DateTime']>;
  department?: InputMaybe<Scalars['String']>;
  documents?: InputMaybe<Array<CreateDocumentInput>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  fundType?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  isFunded?: InputMaybe<Scalars['Boolean']>;
  micr?: InputMaybe<Scalars['String']>;
  principalInvestigator?: InputMaybe<Scalars['String']>;
  protocolNumber?: InputMaybe<Scalars['String']>;
  sponsor?: InputMaybe<Scalars['String']>;
  studyPhase?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  typeOfStudy?: InputMaybe<Scalars['String']>;
};

export type UpdateMeetingInput = {
  _id: Scalars['String'];
  agenda?: InputMaybe<Scalars['String']>;
  lastSubmissionDate?: InputMaybe<Scalars['DateTime']>;
  meetingDate?: InputMaybe<Scalars['DateTime']>;
  meetingId?: InputMaybe<Scalars['String']>;
  meetingType?: InputMaybe<Scalars['String']>;
  mom?: InputMaybe<Scalars['String']>;
  projects?: InputMaybe<Array<ProjectInput>>;
};

export type UpdateUserInput = {
  _id: Scalars['String'];
  avatar?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['String']>;
};

export type User = {
  __typename?: 'User';
  _id: Scalars['String'];
  avatar?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  email: Scalars['String'];
  name: Scalars['String'];
  password: Scalars['String'];
  role: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type UserEcmOutput = {
  __typename?: 'UserECMOutput';
  GCPCertificate: Array<Scalars['String']>;
  _id?: Maybe<Scalars['String']>;
  avatar?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  cv: Scalars['String'];
  dateOFTenureCompletion: Scalars['DateTime'];
  dateOfAppointment: Scalars['DateTime'];
  dateOfCertification: Scalars['DateTime'];
  dateOfResignation: Scalars['DateTime'];
  email?: Maybe<Scalars['String']>;
  isAffiliatedToMedanta: Scalars['Boolean'];
  medicalRegistrationCertificate: Scalars['String'];
  memberType: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  nextGCPCertificateDueOn: Scalars['DateTime'];
  qualification: Array<Scalars['String']>;
  reasonForResignation: Scalars['String'];
  resignLetter: Scalars['String'];
  role?: Maybe<Scalars['String']>;
  rolesInEC: Scalars['String'];
  signedConfidentialityAgreement: Scalars['String'];
  signedConflictOfInterest: Scalars['String'];
  trainings: Array<TraningsOutput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  validUpto: Scalars['DateTime'];
};

export type UserInput = {
  _id: Scalars['String'];
  avatar?: InputMaybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  email: Scalars['String'];
  name: Scalars['String'];
  password: Scalars['String'];
  role: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type UsersEcmOutput = {
  __typename?: 'UsersECMOutput';
  totalCount: Scalars['Int'];
  users: Array<UserEcmOutput>;
};

export type MeetingDoc = {
  __typename?: 'meetingDoc';
  label: Scalars['String'];
  url: Scalars['String'];
};

export type MeetingDocInput = {
  label: Scalars['String'];
  url: Scalars['String'];
};

export type ReadAndAcknowledgeInput = {
  docStackId: Scalars['String'];
  readAndAcknowledge: Scalars['Boolean'];
  submissionId: Scalars['String'];
  submissionType: Scalars['String'];
};

export type SignInMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
}>;


export type SignInMutation = { __typename?: 'Mutation', signin: { __typename?: 'SigninOutput', token: string, user: { __typename?: 'User', _id: string, email: string, name: string, role: string, avatar?: string | null } } };

export type ChangePasswordMutationVariables = Exact<{
  oldPassword: Scalars['String'];
  newPassword: Scalars['String'];
}>;


export type ChangePasswordMutation = { __typename?: 'Mutation', changePassword: { __typename?: 'CommonUserOutput', _id: string, name: string } };

export type FindAllDocStackQueryVariables = Exact<{
  docId: Scalars['String'];
}>;


export type FindAllDocStackQuery = { __typename?: 'Query', findAllDocStack: Array<{ __typename?: 'DocStack', _id: string, readAndAcknowledge: boolean, url: string, remark?: string | null, createdAt: any, comments?: Array<{ __typename?: 'Comments', comment: string, commentedAt: any, commentedBy: { __typename?: 'User', _id: string, name: string, avatar?: string | null } }> | null }> };

export type GetCommentsQueryVariables = Exact<{
  docId: Scalars['String'];
  subType: Scalars['String'];
  submissionType: Scalars['String'];
}>;


export type GetCommentsQuery = { __typename?: 'Query', getComments: string };

export type AddCommentMutationVariables = Exact<{
  docStackId: Scalars['String'];
  comment: Scalars['String'];
}>;


export type AddCommentMutation = { __typename?: 'Mutation', addComment: { __typename?: 'DocStack', _id: string, readAndAcknowledge: boolean, url: string, comments?: Array<{ __typename?: 'Comments', comment: string, commentedAt: any }> | null } };

export type ReUploadDocMutationVariables = Exact<{
  docId: Scalars['String'];
  fileUrl: Scalars['String'];
  submissionId: Scalars['String'];
  submissionType: Scalars['String'];
}>;


export type ReUploadDocMutation = { __typename?: 'Mutation', reUploadDoc: { __typename?: 'DocStack', _id: string, readAndAcknowledge: boolean, url: string, createdAt: any } };

export type ReadAndAcknowledgeMutationVariables = Exact<{
  docStackId: Scalars['String'];
  submissionId: Scalars['String'];
  submissionType: Scalars['String'];
  readAndAcknowledge: Scalars['Boolean'];
}>;


export type ReadAndAcknowledgeMutation = { __typename?: 'Mutation', readAndAcknowledge: { __typename?: 'DocStack', _id: string, readAndAcknowledge: boolean, createdAt: any, url: string } };

export type GetAllEcMemberQueryVariables = Exact<{
  page: Scalars['Int'];
  perPage: Scalars['Int'];
  keyword: Scalars['String'];
  role: Scalars['String'];
}>;


export type GetAllEcMemberQuery = { __typename?: 'Query', getAllUser: { __typename?: 'UsersECMOutput', totalCount: number, users: Array<{ __typename?: 'UserECMOutput', _id?: string | null, email?: string | null, name?: string | null, role?: string | null, rolesInEC: string, qualification: Array<string>, memberType: string, dateOfAppointment: any, isAffiliatedToMedanta: boolean, validUpto: any, avatar?: string | null, createdAt?: any | null, updatedAt?: any | null }> } };

export type GetEcmUserDetailQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetEcmUserDetailQuery = { __typename?: 'Query', getUserById: { __typename?: 'UserECMOutput', _id?: string | null, avatar?: string | null, name?: string | null, role?: string | null, email?: string | null, updatedAt?: any | null, createdAt?: any | null, GCPCertificate: Array<string>, cv: string, dateOFTenureCompletion: any, dateOfAppointment: any, dateOfCertification: any, dateOfResignation: any, resignLetter: string, isAffiliatedToMedanta: boolean, medicalRegistrationCertificate: string, memberType: string, nextGCPCertificateDueOn: any, qualification: Array<string>, reasonForResignation: string, rolesInEC: string, signedConfidentialityAgreement: string, signedConflictOfInterest: string, validUpto: any, trainings: Array<{ __typename?: 'TraningsOutput', url: string, date: any, name: string }> } };

export type CreateEcmUserMutationVariables = Exact<{
  GCPCertificate: Array<Scalars['String']> | Scalars['String'];
  avatar: Scalars['String'];
  cv: Scalars['String'];
  dateOFTenureCompletion: Scalars['DateTime'];
  dateOfAppointment: Scalars['DateTime'];
  dateOfCertification: Scalars['DateTime'];
  dateOfResignation: Scalars['DateTime'];
  resignLetter: Scalars['String'];
  email: Scalars['String'];
  isAffiliatedToMedanta: Scalars['Boolean'];
  medicalRegistrationCertificate: Scalars['String'];
  memberType: Scalars['String'];
  name: Scalars['String'];
  nextGCPCertificateDueOn: Scalars['DateTime'];
  password: Scalars['String'];
  qualification: Array<Scalars['String']> | Scalars['String'];
  reasonForResignation: Scalars['String'];
  role: Scalars['String'];
  rolesInEC: Scalars['String'];
  signedConfidentialityAgreement: Scalars['String'];
  signedConflictOfInterest: Scalars['String'];
  trainings: Array<Tranings> | Tranings;
  validUpto: Scalars['DateTime'];
}>;


export type CreateEcmUserMutation = { __typename?: 'Mutation', createECMUser: { __typename?: 'UserECMOutput', name?: string | null, email?: string | null } };

export type UpdateEcRoleMutationVariables = Exact<{
  _id: Scalars['String'];
  role: Scalars['String'];
  rolesInEC: Scalars['String'];
}>;


export type UpdateEcRoleMutation = { __typename?: 'Mutation', updateRoleInEC: { __typename?: 'UserECMOutput', rolesInEC: string, _id?: string | null } };

export type UpdateEcmMutationVariables = Exact<{
  GCPCertificate: Array<Scalars['String']> | Scalars['String'];
  avatar: Scalars['String'];
  _id: Scalars['String'];
  cv: Scalars['String'];
  dateOFTenureCompletion: Scalars['DateTime'];
  dateOfAppointment: Scalars['DateTime'];
  dateOfCertification: Scalars['DateTime'];
  dateOfResignation: Scalars['DateTime'];
  resignLetter: Scalars['String'];
  isAffiliatedToMedanta: Scalars['Boolean'];
  medicalRegistrationCertificate: Scalars['String'];
  memberType: Scalars['String'];
  name: Scalars['String'];
  nextGCPCertificateDueOn: Scalars['DateTime'];
  qualification: Array<Scalars['String']> | Scalars['String'];
  reasonForResignation: Scalars['String'];
  role: Scalars['String'];
  rolesInEC: Scalars['String'];
  signedConfidentialityAgreement: Scalars['String'];
  signedConflictOfInterest: Scalars['String'];
  trainings: Array<Tranings> | Tranings;
  validUpto: Scalars['DateTime'];
}>;


export type UpdateEcmMutation = { __typename?: 'Mutation', updateECM: { __typename?: 'UserECMOutput', name?: string | null, email?: string | null } };

export type RemoveUserMutationVariables = Exact<{
  _id: Scalars['String'];
}>;


export type RemoveUserMutation = { __typename?: 'Mutation', removeUser: { __typename?: 'User', _id: string } };

export type GetAllEcSubmissionsQueryVariables = Exact<{
  page: Scalars['Int'];
  perPage: Scalars['Int'];
  keyword: Scalars['String'];
}>;


export type GetAllEcSubmissionsQuery = { __typename?: 'Query', getAllECSubmissions: { __typename?: 'ECSubmissionsOutput', totalCount: number, ecs: Array<{ __typename?: 'ECSubmissionOutput', _id: string, type: string, sub_type?: string | null, isAllDocReadAndAcknowledged: boolean, createdAt: any, studyDetails: { __typename?: 'StudyDetailsOutput', department: string, fundType?: string | null, micr?: string | null, principalInvestigator: string, protocolNumber: string, sponsor: string, studyPhase: string, title: string, typeOfStudy?: string | null }, documents?: Array<{ __typename?: 'DocumentsOutput', _id?: string | null, label?: string | null }> | null }> } };

export type GetEcSubmissionByIdInfoQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetEcSubmissionByIdInfoQuery = { __typename?: 'Query', ecSubmission: { __typename?: 'ECSubmissionOutput', type: string, sub_type?: string | null, studyDetails: { __typename?: 'StudyDetailsOutput', protocolNumber: string, emails: Array<string>, isFunded: boolean, micr?: string | null, title: string, sponsor: string, principalInvestigator: string, department: string, studyPhase: string, typeOfStudy?: string | null, fundType?: string | null, dateOfEvent?: any | null, typeOfPVPD?: string | null }, createdBy: { __typename?: 'CommonUserOutput', name: string, role: string, avatar?: string | null }, documents?: Array<{ __typename?: 'DocumentsOutput', _id?: string | null, label?: string | null, isReadAndAcknowledged: boolean }> | null } };

export type GetProtocolListQueryVariables = Exact<{
  subType: Scalars['String'];
  submissionType: Scalars['String'];
}>;


export type GetProtocolListQuery = { __typename?: 'Query', getProtocolList: Array<{ __typename?: 'ProtocolsOutput', _id: string, protocolNumber: string }> };

export type CreateEcsMutationVariables = Exact<{
  department: Scalars['String'];
  emails: Array<Scalars['String']> | Scalars['String'];
  isFunded: Scalars['Boolean'];
  fundType?: InputMaybe<Scalars['String']>;
  micr: Scalars['String'];
  principalInvestigator: Scalars['String'];
  coInvestigator: Scalars['String'];
  protocolNumber: Scalars['String'];
  sponsor: Scalars['String'];
  studyPhase: Scalars['String'];
  title: Scalars['String'];
  typeOfStudy?: InputMaybe<Scalars['String']>;
  documents: Array<CreateDocumentInput> | CreateDocumentInput;
  type: Scalars['String'];
  sub_type?: InputMaybe<Scalars['String']>;
  dateOfEvent?: InputMaybe<Scalars['DateTime']>;
  typeOfPVPD?: InputMaybe<Scalars['String']>;
}>;


export type CreateEcsMutation = { __typename?: 'Mutation', createECS: { __typename?: 'ECSubmissionOutput', _id: string, studyDetails: { __typename?: 'StudyDetailsOutput', principalInvestigator: string, protocolNumber: string } } };

export type RemoveEcsMutationVariables = Exact<{
  _id: Scalars['String'];
}>;


export type RemoveEcsMutation = { __typename?: 'Mutation', removeECS: { __typename?: 'ECSubmissionOutput', _id: string } };

export type CreateIrbSubmissionMutationVariables = Exact<{
  IRBPresentation: Scalars['String'];
  dateOfIRBSubmission: Scalars['DateTime'];
  department: Scalars['String'];
  type: Scalars['String'];
  micr?: InputMaybe<Scalars['String']>;
  documents: Array<CreateDocumentInput> | CreateDocumentInput;
  emails: Array<Scalars['String']> | Scalars['String'];
  fundType: Scalars['String'];
  isFunded: Scalars['Boolean'];
  principalInvestigator: Scalars['String'];
  protocolNumber: Scalars['String'];
  sponsor: Scalars['String'];
  studyPhase: Scalars['String'];
  title: Scalars['String'];
  typeOfStudy: Scalars['String'];
}>;


export type CreateIrbSubmissionMutation = { __typename?: 'Mutation', createIrb: { __typename?: 'IrbOutput', title: string } };

export type UpdateIrbSubmissionMutationVariables = Exact<{
  id: Scalars['String'];
  department?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  micr?: InputMaybe<Scalars['String']>;
  dateOfIRBSubmission: Scalars['DateTime'];
  emails?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  fundType?: InputMaybe<Scalars['String']>;
  isFunded?: InputMaybe<Scalars['Boolean']>;
  principalInvestigator?: InputMaybe<Scalars['String']>;
  protocolNumber?: InputMaybe<Scalars['String']>;
  sponsor?: InputMaybe<Scalars['String']>;
  studyPhase?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  typeOfStudy?: InputMaybe<Scalars['String']>;
}>;


export type UpdateIrbSubmissionMutation = { __typename?: 'Mutation', updateIrb: { __typename?: 'IrbOutput', title: string } };

export type GetAllIrbSubmissionsQueryVariables = Exact<{
  type: Scalars['String'];
  page: Scalars['Int'];
  perPage: Scalars['Int'];
  keyword: Scalars['String'];
}>;


export type GetAllIrbSubmissionsQuery = { __typename?: 'Query', getAllIRBSubmissions: { __typename?: 'IrbsOutput', totalCount: number, irbs: Array<{ __typename?: 'IrbOutput', _id: string, emails: Array<string>, typeOfStudy: string, sponsor: string, title: string, dateOfIRBSubmission: any, protocolNumber: string, isAllDocReadAndAcknowledged: boolean, micr?: string | null, principalInvestigator: string, department: string, createdAt: any }> } };

export type GetIrbSubmissionInfoQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetIrbSubmissionInfoQuery = { __typename?: 'Query', irb: { __typename?: 'IrbOutput', IRBPresentation: string, type: string, dateOfIRBSubmission: any, department: string, micr?: string | null, emails: Array<string>, fundType: string, isFunded: boolean, principalInvestigator: string, protocolNumber: string, sponsor: string, studyPhase: string, title: string, typeOfStudy: string, createdBy: { __typename?: 'CommonUserOutput', name: string, role: string, avatar?: string | null }, documents?: Array<{ __typename?: 'DocumentsOutput', _id?: string | null, label?: string | null, isReadAndAcknowledged: boolean }> | null } };

export type RemoveIrbMutationVariables = Exact<{
  _id: Scalars['String'];
}>;


export type RemoveIrbMutation = { __typename?: 'Mutation', removeIrb: { __typename?: 'IrbOutput', _id: string } };

export type GetSubmissionDropdownListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSubmissionDropdownListQuery = { __typename?: 'Query', getSubmissionDropdownList: { __typename?: 'DropdownListOutput', department: Array<string>, sponsor: Array<string>, principalInvestigator: Array<string>, coInvestigator: Array<string> } };

export type CreateMeetingMutationVariables = Exact<{
  agenda: Scalars['String'];
  lastSubmissionDate: Scalars['DateTime'];
  meetingDate: Scalars['DateTime'];
  meetingId: Scalars['String'];
  meetingType: Scalars['String'];
}>;


export type CreateMeetingMutation = { __typename?: 'Mutation', createMeeting: { __typename?: 'Meeting', _id: string } };

export type UpdateMeetingMutationVariables = Exact<{
  _id: Scalars['String'];
  agenda: Scalars['String'];
  lastSubmissionDate: Scalars['DateTime'];
  meetingDate: Scalars['DateTime'];
  meetingId: Scalars['String'];
  mom?: InputMaybe<Scalars['String']>;
  meetingType: Scalars['String'];
  projects?: InputMaybe<Array<ProjectInput> | ProjectInput>;
}>;


export type UpdateMeetingMutation = { __typename?: 'Mutation', updateMeeting: { __typename?: 'Meeting', _id: string } };

export type GetAllMeetingsQueryVariables = Exact<{
  meetingDate: Scalars['String'];
  meetingType: Scalars['String'];
  page: Scalars['Int'];
  perPage: Scalars['Int'];
}>;


export type GetAllMeetingsQuery = { __typename?: 'Query', getAllMeetings: { __typename?: 'MeetingOutput', totalCount: number, meetings: Array<{ __typename?: 'Meeting', _id: string, meetingId: string, agenda: string, meetingDate: any, lastSubmissionDate: any, meetingType: string }> } };

export type FindOneMeetingQueryVariables = Exact<{
  _id: Scalars['String'];
}>;


export type FindOneMeetingQuery = { __typename?: 'Query', findOneMeeting: { __typename?: 'MeetingSingleOutput', _id: string, meetingId: string, agenda: string, meetingDate: any, lastSubmissionDate: any, mom?: string | null, meetingType?: string | null, projects?: Array<{ __typename?: 'ProjectOutput', _id: { __typename?: 'Irb', _id: string, title: string }, documents: Array<{ __typename?: 'meetingDoc', label: string, url: string }> }> | null } };

export type RemoveMeetingMutationVariables = Exact<{
  _id: Scalars['String'];
}>;


export type RemoveMeetingMutation = { __typename?: 'Mutation', removeMeeting: { __typename?: 'Meeting', _id: string } };

export type GetUserByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetUserByIdQuery = { __typename?: 'Query', getUserById: { __typename?: 'UserECMOutput', avatar?: string | null, name?: string | null, role?: string | null, email?: string | null, updatedAt?: any | null } };

export type UpdateUserMutationVariables = Exact<{
  id: Scalars['String'];
  avatar?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['String']>;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'UserECMOutput', avatar?: string | null, name?: string | null, role?: string | null, email?: string | null, updatedAt?: any | null } };


export const SignInDocument = gql`
    mutation SignIn($email: String!, $password: String!) {
  signin(signinInput: {email: $email, password: $password}) {
    token
    user {
      _id
      email
      name
      role
      avatar
    }
  }
}
    `;
export type SignInMutationFn = Apollo.MutationFunction<SignInMutation, SignInMutationVariables>;

/**
 * __useSignInMutation__
 *
 * To run a mutation, you first call `useSignInMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignInMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signInMutation, { data, loading, error }] = useSignInMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useSignInMutation(baseOptions?: Apollo.MutationHookOptions<SignInMutation, SignInMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignInMutation, SignInMutationVariables>(SignInDocument, options);
      }
export type SignInMutationHookResult = ReturnType<typeof useSignInMutation>;
export type SignInMutationResult = Apollo.MutationResult<SignInMutation>;
export type SignInMutationOptions = Apollo.BaseMutationOptions<SignInMutation, SignInMutationVariables>;
export const ChangePasswordDocument = gql`
    mutation ChangePassword($oldPassword: String!, $newPassword: String!) {
  changePassword(
    changePasswordInput: {oldPassword: $oldPassword, newPassword: $newPassword}
  ) {
    _id
    name
  }
}
    `;
export type ChangePasswordMutationFn = Apollo.MutationFunction<ChangePasswordMutation, ChangePasswordMutationVariables>;

/**
 * __useChangePasswordMutation__
 *
 * To run a mutation, you first call `useChangePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePasswordMutation, { data, loading, error }] = useChangePasswordMutation({
 *   variables: {
 *      oldPassword: // value for 'oldPassword'
 *      newPassword: // value for 'newPassword'
 *   },
 * });
 */
export function useChangePasswordMutation(baseOptions?: Apollo.MutationHookOptions<ChangePasswordMutation, ChangePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangePasswordMutation, ChangePasswordMutationVariables>(ChangePasswordDocument, options);
      }
export type ChangePasswordMutationHookResult = ReturnType<typeof useChangePasswordMutation>;
export type ChangePasswordMutationResult = Apollo.MutationResult<ChangePasswordMutation>;
export type ChangePasswordMutationOptions = Apollo.BaseMutationOptions<ChangePasswordMutation, ChangePasswordMutationVariables>;
export const FindAllDocStackDocument = gql`
    query FindAllDocStack($docId: String!) {
  findAllDocStack(docId: $docId) {
    _id
    readAndAcknowledge
    url
    remark
    createdAt
    comments {
      comment
      commentedAt
      commentedBy {
        _id
        name
        avatar
      }
    }
  }
}
    `;

/**
 * __useFindAllDocStackQuery__
 *
 * To run a query within a React component, call `useFindAllDocStackQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllDocStackQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllDocStackQuery({
 *   variables: {
 *      docId: // value for 'docId'
 *   },
 * });
 */
export function useFindAllDocStackQuery(baseOptions: Apollo.QueryHookOptions<FindAllDocStackQuery, FindAllDocStackQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllDocStackQuery, FindAllDocStackQueryVariables>(FindAllDocStackDocument, options);
      }
export function useFindAllDocStackLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllDocStackQuery, FindAllDocStackQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllDocStackQuery, FindAllDocStackQueryVariables>(FindAllDocStackDocument, options);
        }
export type FindAllDocStackQueryHookResult = ReturnType<typeof useFindAllDocStackQuery>;
export type FindAllDocStackLazyQueryHookResult = ReturnType<typeof useFindAllDocStackLazyQuery>;
export type FindAllDocStackQueryResult = Apollo.QueryResult<FindAllDocStackQuery, FindAllDocStackQueryVariables>;
export const GetCommentsDocument = gql`
    query getComments($docId: String!, $subType: String!, $submissionType: String!) {
  getComments(docId: $docId, subType: $subType, submissionType: $submissionType)
}
    `;

/**
 * __useGetCommentsQuery__
 *
 * To run a query within a React component, call `useGetCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommentsQuery({
 *   variables: {
 *      docId: // value for 'docId'
 *      subType: // value for 'subType'
 *      submissionType: // value for 'submissionType'
 *   },
 * });
 */
export function useGetCommentsQuery(baseOptions: Apollo.QueryHookOptions<GetCommentsQuery, GetCommentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommentsQuery, GetCommentsQueryVariables>(GetCommentsDocument, options);
      }
export function useGetCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommentsQuery, GetCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommentsQuery, GetCommentsQueryVariables>(GetCommentsDocument, options);
        }
export type GetCommentsQueryHookResult = ReturnType<typeof useGetCommentsQuery>;
export type GetCommentsLazyQueryHookResult = ReturnType<typeof useGetCommentsLazyQuery>;
export type GetCommentsQueryResult = Apollo.QueryResult<GetCommentsQuery, GetCommentsQueryVariables>;
export const AddCommentDocument = gql`
    mutation addComment($docStackId: String!, $comment: String!) {
  addComment(createCommentInput: {docStackId: $docStackId, comment: $comment}) {
    _id
    readAndAcknowledge
    url
    comments {
      comment
      commentedAt
    }
  }
}
    `;
export type AddCommentMutationFn = Apollo.MutationFunction<AddCommentMutation, AddCommentMutationVariables>;

/**
 * __useAddCommentMutation__
 *
 * To run a mutation, you first call `useAddCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCommentMutation, { data, loading, error }] = useAddCommentMutation({
 *   variables: {
 *      docStackId: // value for 'docStackId'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useAddCommentMutation(baseOptions?: Apollo.MutationHookOptions<AddCommentMutation, AddCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCommentMutation, AddCommentMutationVariables>(AddCommentDocument, options);
      }
export type AddCommentMutationHookResult = ReturnType<typeof useAddCommentMutation>;
export type AddCommentMutationResult = Apollo.MutationResult<AddCommentMutation>;
export type AddCommentMutationOptions = Apollo.BaseMutationOptions<AddCommentMutation, AddCommentMutationVariables>;
export const ReUploadDocDocument = gql`
    mutation reUploadDoc($docId: String!, $fileUrl: String!, $submissionId: String!, $submissionType: String!) {
  reUploadDoc(
    reUploadDocInput: {docId: $docId, fileUrl: $fileUrl, submissionId: $submissionId, submissionType: $submissionType}
  ) {
    _id
    readAndAcknowledge
    url
    createdAt
  }
}
    `;
export type ReUploadDocMutationFn = Apollo.MutationFunction<ReUploadDocMutation, ReUploadDocMutationVariables>;

/**
 * __useReUploadDocMutation__
 *
 * To run a mutation, you first call `useReUploadDocMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReUploadDocMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reUploadDocMutation, { data, loading, error }] = useReUploadDocMutation({
 *   variables: {
 *      docId: // value for 'docId'
 *      fileUrl: // value for 'fileUrl'
 *      submissionId: // value for 'submissionId'
 *      submissionType: // value for 'submissionType'
 *   },
 * });
 */
export function useReUploadDocMutation(baseOptions?: Apollo.MutationHookOptions<ReUploadDocMutation, ReUploadDocMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReUploadDocMutation, ReUploadDocMutationVariables>(ReUploadDocDocument, options);
      }
export type ReUploadDocMutationHookResult = ReturnType<typeof useReUploadDocMutation>;
export type ReUploadDocMutationResult = Apollo.MutationResult<ReUploadDocMutation>;
export type ReUploadDocMutationOptions = Apollo.BaseMutationOptions<ReUploadDocMutation, ReUploadDocMutationVariables>;
export const ReadAndAcknowledgeDocument = gql`
    mutation readAndAcknowledge($docStackId: String!, $submissionId: String!, $submissionType: String!, $readAndAcknowledge: Boolean!) {
  readAndAcknowledge(
    readAndAcknowledgeInput: {docStackId: $docStackId, submissionId: $submissionId, submissionType: $submissionType, readAndAcknowledge: $readAndAcknowledge}
  ) {
    _id
    readAndAcknowledge
    createdAt
    url
  }
}
    `;
export type ReadAndAcknowledgeMutationFn = Apollo.MutationFunction<ReadAndAcknowledgeMutation, ReadAndAcknowledgeMutationVariables>;

/**
 * __useReadAndAcknowledgeMutation__
 *
 * To run a mutation, you first call `useReadAndAcknowledgeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReadAndAcknowledgeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [readAndAcknowledgeMutation, { data, loading, error }] = useReadAndAcknowledgeMutation({
 *   variables: {
 *      docStackId: // value for 'docStackId'
 *      submissionId: // value for 'submissionId'
 *      submissionType: // value for 'submissionType'
 *      readAndAcknowledge: // value for 'readAndAcknowledge'
 *   },
 * });
 */
export function useReadAndAcknowledgeMutation(baseOptions?: Apollo.MutationHookOptions<ReadAndAcknowledgeMutation, ReadAndAcknowledgeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReadAndAcknowledgeMutation, ReadAndAcknowledgeMutationVariables>(ReadAndAcknowledgeDocument, options);
      }
export type ReadAndAcknowledgeMutationHookResult = ReturnType<typeof useReadAndAcknowledgeMutation>;
export type ReadAndAcknowledgeMutationResult = Apollo.MutationResult<ReadAndAcknowledgeMutation>;
export type ReadAndAcknowledgeMutationOptions = Apollo.BaseMutationOptions<ReadAndAcknowledgeMutation, ReadAndAcknowledgeMutationVariables>;
export const GetAllEcMemberDocument = gql`
    query GetAllEcMember($page: Int!, $perPage: Int!, $keyword: String!, $role: String!) {
  getAllUser(page: $page, perPage: $perPage, keyword: $keyword, role: $role) {
    users {
      _id
      email
      name
      role
      rolesInEC
      qualification
      memberType
      dateOfAppointment
      isAffiliatedToMedanta
      validUpto
      avatar
      createdAt
      updatedAt
    }
    totalCount
  }
}
    `;

/**
 * __useGetAllEcMemberQuery__
 *
 * To run a query within a React component, call `useGetAllEcMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllEcMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllEcMemberQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      keyword: // value for 'keyword'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useGetAllEcMemberQuery(baseOptions: Apollo.QueryHookOptions<GetAllEcMemberQuery, GetAllEcMemberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllEcMemberQuery, GetAllEcMemberQueryVariables>(GetAllEcMemberDocument, options);
      }
export function useGetAllEcMemberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllEcMemberQuery, GetAllEcMemberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllEcMemberQuery, GetAllEcMemberQueryVariables>(GetAllEcMemberDocument, options);
        }
export type GetAllEcMemberQueryHookResult = ReturnType<typeof useGetAllEcMemberQuery>;
export type GetAllEcMemberLazyQueryHookResult = ReturnType<typeof useGetAllEcMemberLazyQuery>;
export type GetAllEcMemberQueryResult = Apollo.QueryResult<GetAllEcMemberQuery, GetAllEcMemberQueryVariables>;
export const GetEcmUserDetailDocument = gql`
    query GetECMUserDetail($id: String!) {
  getUserById(_id: $id) {
    _id
    avatar
    name
    role
    email
    updatedAt
    createdAt
    GCPCertificate
    cv
    dateOFTenureCompletion
    dateOfAppointment
    dateOfCertification
    dateOfResignation
    resignLetter
    isAffiliatedToMedanta
    medicalRegistrationCertificate
    memberType
    nextGCPCertificateDueOn
    qualification
    reasonForResignation
    rolesInEC
    signedConfidentialityAgreement
    signedConflictOfInterest
    trainings {
      url
      date
      name
    }
    validUpto
  }
}
    `;

/**
 * __useGetEcmUserDetailQuery__
 *
 * To run a query within a React component, call `useGetEcmUserDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEcmUserDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEcmUserDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEcmUserDetailQuery(baseOptions: Apollo.QueryHookOptions<GetEcmUserDetailQuery, GetEcmUserDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEcmUserDetailQuery, GetEcmUserDetailQueryVariables>(GetEcmUserDetailDocument, options);
      }
export function useGetEcmUserDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEcmUserDetailQuery, GetEcmUserDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEcmUserDetailQuery, GetEcmUserDetailQueryVariables>(GetEcmUserDetailDocument, options);
        }
export type GetEcmUserDetailQueryHookResult = ReturnType<typeof useGetEcmUserDetailQuery>;
export type GetEcmUserDetailLazyQueryHookResult = ReturnType<typeof useGetEcmUserDetailLazyQuery>;
export type GetEcmUserDetailQueryResult = Apollo.QueryResult<GetEcmUserDetailQuery, GetEcmUserDetailQueryVariables>;
export const CreateEcmUserDocument = gql`
    mutation createECMUser($GCPCertificate: [String!]!, $avatar: String!, $cv: String!, $dateOFTenureCompletion: DateTime!, $dateOfAppointment: DateTime!, $dateOfCertification: DateTime!, $dateOfResignation: DateTime!, $resignLetter: String!, $email: String!, $isAffiliatedToMedanta: Boolean!, $medicalRegistrationCertificate: String!, $memberType: String!, $name: String!, $nextGCPCertificateDueOn: DateTime!, $password: String!, $qualification: [String!]!, $reasonForResignation: String!, $role: String!, $rolesInEC: String!, $signedConfidentialityAgreement: String!, $signedConflictOfInterest: String!, $trainings: [Tranings!]!, $validUpto: DateTime!) {
  createECMUser(
    createECMUser: {GCPCertificate: $GCPCertificate, avatar: $avatar, cv: $cv, dateOFTenureCompletion: $dateOFTenureCompletion, dateOfAppointment: $dateOfAppointment, dateOfCertification: $dateOfCertification, dateOfResignation: $dateOfResignation, resignLetter: $resignLetter, email: $email, isAffiliatedToMedanta: $isAffiliatedToMedanta, medicalRegistrationCertificate: $medicalRegistrationCertificate, memberType: $memberType, name: $name, nextGCPCertificateDueOn: $nextGCPCertificateDueOn, password: $password, qualification: $qualification, reasonForResignation: $reasonForResignation, role: $role, rolesInEC: $rolesInEC, signedConfidentialityAgreement: $signedConfidentialityAgreement, signedConflictOfInterest: $signedConflictOfInterest, validUpto: $validUpto, trainings: $trainings}
  ) {
    name
    email
  }
}
    `;
export type CreateEcmUserMutationFn = Apollo.MutationFunction<CreateEcmUserMutation, CreateEcmUserMutationVariables>;

/**
 * __useCreateEcmUserMutation__
 *
 * To run a mutation, you first call `useCreateEcmUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEcmUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEcmUserMutation, { data, loading, error }] = useCreateEcmUserMutation({
 *   variables: {
 *      GCPCertificate: // value for 'GCPCertificate'
 *      avatar: // value for 'avatar'
 *      cv: // value for 'cv'
 *      dateOFTenureCompletion: // value for 'dateOFTenureCompletion'
 *      dateOfAppointment: // value for 'dateOfAppointment'
 *      dateOfCertification: // value for 'dateOfCertification'
 *      dateOfResignation: // value for 'dateOfResignation'
 *      resignLetter: // value for 'resignLetter'
 *      email: // value for 'email'
 *      isAffiliatedToMedanta: // value for 'isAffiliatedToMedanta'
 *      medicalRegistrationCertificate: // value for 'medicalRegistrationCertificate'
 *      memberType: // value for 'memberType'
 *      name: // value for 'name'
 *      nextGCPCertificateDueOn: // value for 'nextGCPCertificateDueOn'
 *      password: // value for 'password'
 *      qualification: // value for 'qualification'
 *      reasonForResignation: // value for 'reasonForResignation'
 *      role: // value for 'role'
 *      rolesInEC: // value for 'rolesInEC'
 *      signedConfidentialityAgreement: // value for 'signedConfidentialityAgreement'
 *      signedConflictOfInterest: // value for 'signedConflictOfInterest'
 *      trainings: // value for 'trainings'
 *      validUpto: // value for 'validUpto'
 *   },
 * });
 */
export function useCreateEcmUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateEcmUserMutation, CreateEcmUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEcmUserMutation, CreateEcmUserMutationVariables>(CreateEcmUserDocument, options);
      }
export type CreateEcmUserMutationHookResult = ReturnType<typeof useCreateEcmUserMutation>;
export type CreateEcmUserMutationResult = Apollo.MutationResult<CreateEcmUserMutation>;
export type CreateEcmUserMutationOptions = Apollo.BaseMutationOptions<CreateEcmUserMutation, CreateEcmUserMutationVariables>;
export const UpdateEcRoleDocument = gql`
    mutation updateECRole($_id: String!, $role: String!, $rolesInEC: String!) {
  updateRoleInEC(roleInEC: {_id: $_id, role: $role, rolesInEC: $rolesInEC}) {
    rolesInEC
    _id
  }
}
    `;
export type UpdateEcRoleMutationFn = Apollo.MutationFunction<UpdateEcRoleMutation, UpdateEcRoleMutationVariables>;

/**
 * __useUpdateEcRoleMutation__
 *
 * To run a mutation, you first call `useUpdateEcRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEcRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEcRoleMutation, { data, loading, error }] = useUpdateEcRoleMutation({
 *   variables: {
 *      _id: // value for '_id'
 *      role: // value for 'role'
 *      rolesInEC: // value for 'rolesInEC'
 *   },
 * });
 */
export function useUpdateEcRoleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEcRoleMutation, UpdateEcRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEcRoleMutation, UpdateEcRoleMutationVariables>(UpdateEcRoleDocument, options);
      }
export type UpdateEcRoleMutationHookResult = ReturnType<typeof useUpdateEcRoleMutation>;
export type UpdateEcRoleMutationResult = Apollo.MutationResult<UpdateEcRoleMutation>;
export type UpdateEcRoleMutationOptions = Apollo.BaseMutationOptions<UpdateEcRoleMutation, UpdateEcRoleMutationVariables>;
export const UpdateEcmDocument = gql`
    mutation updateECM($GCPCertificate: [String!]!, $avatar: String!, $_id: String!, $cv: String!, $dateOFTenureCompletion: DateTime!, $dateOfAppointment: DateTime!, $dateOfCertification: DateTime!, $dateOfResignation: DateTime!, $resignLetter: String!, $isAffiliatedToMedanta: Boolean!, $medicalRegistrationCertificate: String!, $memberType: String!, $name: String!, $nextGCPCertificateDueOn: DateTime!, $qualification: [String!]!, $reasonForResignation: String!, $role: String!, $rolesInEC: String!, $signedConfidentialityAgreement: String!, $signedConflictOfInterest: String!, $trainings: [Tranings!]!, $validUpto: DateTime!) {
  updateECM(
    updateECMUserInput: {GCPCertificate: $GCPCertificate, avatar: $avatar, _id: $_id, cv: $cv, dateOFTenureCompletion: $dateOFTenureCompletion, dateOfAppointment: $dateOfAppointment, dateOfCertification: $dateOfCertification, dateOfResignation: $dateOfResignation, resignLetter: $resignLetter, isAffiliatedToMedanta: $isAffiliatedToMedanta, medicalRegistrationCertificate: $medicalRegistrationCertificate, memberType: $memberType, name: $name, nextGCPCertificateDueOn: $nextGCPCertificateDueOn, qualification: $qualification, reasonForResignation: $reasonForResignation, role: $role, rolesInEC: $rolesInEC, signedConfidentialityAgreement: $signedConfidentialityAgreement, signedConflictOfInterest: $signedConflictOfInterest, validUpto: $validUpto, trainings: $trainings}
  ) {
    name
    email
  }
}
    `;
export type UpdateEcmMutationFn = Apollo.MutationFunction<UpdateEcmMutation, UpdateEcmMutationVariables>;

/**
 * __useUpdateEcmMutation__
 *
 * To run a mutation, you first call `useUpdateEcmMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEcmMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEcmMutation, { data, loading, error }] = useUpdateEcmMutation({
 *   variables: {
 *      GCPCertificate: // value for 'GCPCertificate'
 *      avatar: // value for 'avatar'
 *      _id: // value for '_id'
 *      cv: // value for 'cv'
 *      dateOFTenureCompletion: // value for 'dateOFTenureCompletion'
 *      dateOfAppointment: // value for 'dateOfAppointment'
 *      dateOfCertification: // value for 'dateOfCertification'
 *      dateOfResignation: // value for 'dateOfResignation'
 *      resignLetter: // value for 'resignLetter'
 *      isAffiliatedToMedanta: // value for 'isAffiliatedToMedanta'
 *      medicalRegistrationCertificate: // value for 'medicalRegistrationCertificate'
 *      memberType: // value for 'memberType'
 *      name: // value for 'name'
 *      nextGCPCertificateDueOn: // value for 'nextGCPCertificateDueOn'
 *      qualification: // value for 'qualification'
 *      reasonForResignation: // value for 'reasonForResignation'
 *      role: // value for 'role'
 *      rolesInEC: // value for 'rolesInEC'
 *      signedConfidentialityAgreement: // value for 'signedConfidentialityAgreement'
 *      signedConflictOfInterest: // value for 'signedConflictOfInterest'
 *      trainings: // value for 'trainings'
 *      validUpto: // value for 'validUpto'
 *   },
 * });
 */
export function useUpdateEcmMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEcmMutation, UpdateEcmMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEcmMutation, UpdateEcmMutationVariables>(UpdateEcmDocument, options);
      }
export type UpdateEcmMutationHookResult = ReturnType<typeof useUpdateEcmMutation>;
export type UpdateEcmMutationResult = Apollo.MutationResult<UpdateEcmMutation>;
export type UpdateEcmMutationOptions = Apollo.BaseMutationOptions<UpdateEcmMutation, UpdateEcmMutationVariables>;
export const RemoveUserDocument = gql`
    mutation removeUser($_id: String!) {
  removeUser(_id: $_id) {
    _id
  }
}
    `;
export type RemoveUserMutationFn = Apollo.MutationFunction<RemoveUserMutation, RemoveUserMutationVariables>;

/**
 * __useRemoveUserMutation__
 *
 * To run a mutation, you first call `useRemoveUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserMutation, { data, loading, error }] = useRemoveUserMutation({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useRemoveUserMutation(baseOptions?: Apollo.MutationHookOptions<RemoveUserMutation, RemoveUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveUserMutation, RemoveUserMutationVariables>(RemoveUserDocument, options);
      }
export type RemoveUserMutationHookResult = ReturnType<typeof useRemoveUserMutation>;
export type RemoveUserMutationResult = Apollo.MutationResult<RemoveUserMutation>;
export type RemoveUserMutationOptions = Apollo.BaseMutationOptions<RemoveUserMutation, RemoveUserMutationVariables>;
export const GetAllEcSubmissionsDocument = gql`
    query GetAllECSubmissions($page: Int!, $perPage: Int!, $keyword: String!) {
  getAllECSubmissions(page: $page, perPage: $perPage, keyword: $keyword) {
    ecs {
      _id
      type
      sub_type
      isAllDocReadAndAcknowledged
      studyDetails {
        department
        fundType
        micr
        principalInvestigator
        protocolNumber
        sponsor
        studyPhase
        title
        typeOfStudy
      }
      documents {
        _id
        label
      }
      createdAt
    }
    totalCount
  }
}
    `;

/**
 * __useGetAllEcSubmissionsQuery__
 *
 * To run a query within a React component, call `useGetAllEcSubmissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllEcSubmissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllEcSubmissionsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      keyword: // value for 'keyword'
 *   },
 * });
 */
export function useGetAllEcSubmissionsQuery(baseOptions: Apollo.QueryHookOptions<GetAllEcSubmissionsQuery, GetAllEcSubmissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllEcSubmissionsQuery, GetAllEcSubmissionsQueryVariables>(GetAllEcSubmissionsDocument, options);
      }
export function useGetAllEcSubmissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllEcSubmissionsQuery, GetAllEcSubmissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllEcSubmissionsQuery, GetAllEcSubmissionsQueryVariables>(GetAllEcSubmissionsDocument, options);
        }
export type GetAllEcSubmissionsQueryHookResult = ReturnType<typeof useGetAllEcSubmissionsQuery>;
export type GetAllEcSubmissionsLazyQueryHookResult = ReturnType<typeof useGetAllEcSubmissionsLazyQuery>;
export type GetAllEcSubmissionsQueryResult = Apollo.QueryResult<GetAllEcSubmissionsQuery, GetAllEcSubmissionsQueryVariables>;
export const GetEcSubmissionByIdInfoDocument = gql`
    query GetECSubmissionByIdInfo($id: String!) {
  ecSubmission(id: $id) {
    type
    sub_type
    studyDetails {
      protocolNumber
      emails
      isFunded
      micr
      title
      sponsor
      principalInvestigator
      department
      studyPhase
      typeOfStudy
      fundType
      dateOfEvent
      typeOfStudy
      typeOfPVPD
    }
    createdBy {
      name
      role
      avatar
    }
    documents {
      _id
      label
      isReadAndAcknowledged
    }
  }
}
    `;

/**
 * __useGetEcSubmissionByIdInfoQuery__
 *
 * To run a query within a React component, call `useGetEcSubmissionByIdInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEcSubmissionByIdInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEcSubmissionByIdInfoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEcSubmissionByIdInfoQuery(baseOptions: Apollo.QueryHookOptions<GetEcSubmissionByIdInfoQuery, GetEcSubmissionByIdInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEcSubmissionByIdInfoQuery, GetEcSubmissionByIdInfoQueryVariables>(GetEcSubmissionByIdInfoDocument, options);
      }
export function useGetEcSubmissionByIdInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEcSubmissionByIdInfoQuery, GetEcSubmissionByIdInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEcSubmissionByIdInfoQuery, GetEcSubmissionByIdInfoQueryVariables>(GetEcSubmissionByIdInfoDocument, options);
        }
export type GetEcSubmissionByIdInfoQueryHookResult = ReturnType<typeof useGetEcSubmissionByIdInfoQuery>;
export type GetEcSubmissionByIdInfoLazyQueryHookResult = ReturnType<typeof useGetEcSubmissionByIdInfoLazyQuery>;
export type GetEcSubmissionByIdInfoQueryResult = Apollo.QueryResult<GetEcSubmissionByIdInfoQuery, GetEcSubmissionByIdInfoQueryVariables>;
export const GetProtocolListDocument = gql`
    query getProtocolList($subType: String!, $submissionType: String!) {
  getProtocolList(subType: $subType, submissionType: $submissionType) {
    _id
    protocolNumber
  }
}
    `;

/**
 * __useGetProtocolListQuery__
 *
 * To run a query within a React component, call `useGetProtocolListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProtocolListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProtocolListQuery({
 *   variables: {
 *      subType: // value for 'subType'
 *      submissionType: // value for 'submissionType'
 *   },
 * });
 */
export function useGetProtocolListQuery(baseOptions: Apollo.QueryHookOptions<GetProtocolListQuery, GetProtocolListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProtocolListQuery, GetProtocolListQueryVariables>(GetProtocolListDocument, options);
      }
export function useGetProtocolListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProtocolListQuery, GetProtocolListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProtocolListQuery, GetProtocolListQueryVariables>(GetProtocolListDocument, options);
        }
export type GetProtocolListQueryHookResult = ReturnType<typeof useGetProtocolListQuery>;
export type GetProtocolListLazyQueryHookResult = ReturnType<typeof useGetProtocolListLazyQuery>;
export type GetProtocolListQueryResult = Apollo.QueryResult<GetProtocolListQuery, GetProtocolListQueryVariables>;
export const CreateEcsDocument = gql`
    mutation CreateECS($department: String!, $emails: [String!]!, $isFunded: Boolean!, $fundType: String, $micr: String!, $principalInvestigator: String!, $coInvestigator: String!, $protocolNumber: String!, $sponsor: String!, $studyPhase: String!, $title: String!, $typeOfStudy: String, $documents: [CreateDocumentInput!]!, $type: String!, $sub_type: String, $dateOfEvent: DateTime, $typeOfPVPD: String) {
  createECS(
    createECSubmissionInput: {documents: $documents, studyDetails: {department: $department, emails: $emails, isFunded: $isFunded, fundType: $fundType, micr: $micr, principalInvestigator: $principalInvestigator, coInvestigator: $coInvestigator, protocolNumber: $protocolNumber, sponsor: $sponsor, studyPhase: $studyPhase, title: $title, typeOfStudy: $typeOfStudy, dateOfEvent: $dateOfEvent, typeOfPVPD: $typeOfPVPD}, type: $type, sub_type: $sub_type}
  ) {
    _id
    studyDetails {
      principalInvestigator
      protocolNumber
    }
  }
}
    `;
export type CreateEcsMutationFn = Apollo.MutationFunction<CreateEcsMutation, CreateEcsMutationVariables>;

/**
 * __useCreateEcsMutation__
 *
 * To run a mutation, you first call `useCreateEcsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEcsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEcsMutation, { data, loading, error }] = useCreateEcsMutation({
 *   variables: {
 *      department: // value for 'department'
 *      emails: // value for 'emails'
 *      isFunded: // value for 'isFunded'
 *      fundType: // value for 'fundType'
 *      micr: // value for 'micr'
 *      principalInvestigator: // value for 'principalInvestigator'
 *      coInvestigator: // value for 'coInvestigator'
 *      protocolNumber: // value for 'protocolNumber'
 *      sponsor: // value for 'sponsor'
 *      studyPhase: // value for 'studyPhase'
 *      title: // value for 'title'
 *      typeOfStudy: // value for 'typeOfStudy'
 *      documents: // value for 'documents'
 *      type: // value for 'type'
 *      sub_type: // value for 'sub_type'
 *      dateOfEvent: // value for 'dateOfEvent'
 *      typeOfPVPD: // value for 'typeOfPVPD'
 *   },
 * });
 */
export function useCreateEcsMutation(baseOptions?: Apollo.MutationHookOptions<CreateEcsMutation, CreateEcsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEcsMutation, CreateEcsMutationVariables>(CreateEcsDocument, options);
      }
export type CreateEcsMutationHookResult = ReturnType<typeof useCreateEcsMutation>;
export type CreateEcsMutationResult = Apollo.MutationResult<CreateEcsMutation>;
export type CreateEcsMutationOptions = Apollo.BaseMutationOptions<CreateEcsMutation, CreateEcsMutationVariables>;
export const RemoveEcsDocument = gql`
    mutation removeECS($_id: String!) {
  removeECS(_id: $_id) {
    _id
  }
}
    `;
export type RemoveEcsMutationFn = Apollo.MutationFunction<RemoveEcsMutation, RemoveEcsMutationVariables>;

/**
 * __useRemoveEcsMutation__
 *
 * To run a mutation, you first call `useRemoveEcsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveEcsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeEcsMutation, { data, loading, error }] = useRemoveEcsMutation({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useRemoveEcsMutation(baseOptions?: Apollo.MutationHookOptions<RemoveEcsMutation, RemoveEcsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveEcsMutation, RemoveEcsMutationVariables>(RemoveEcsDocument, options);
      }
export type RemoveEcsMutationHookResult = ReturnType<typeof useRemoveEcsMutation>;
export type RemoveEcsMutationResult = Apollo.MutationResult<RemoveEcsMutation>;
export type RemoveEcsMutationOptions = Apollo.BaseMutationOptions<RemoveEcsMutation, RemoveEcsMutationVariables>;
export const CreateIrbSubmissionDocument = gql`
    mutation CreateIRBSubmission($IRBPresentation: String!, $dateOfIRBSubmission: DateTime!, $department: String!, $type: String!, $micr: String, $documents: [CreateDocumentInput!]!, $emails: [String!]!, $fundType: String!, $isFunded: Boolean!, $principalInvestigator: String!, $protocolNumber: String!, $sponsor: String!, $studyPhase: String!, $title: String!, $typeOfStudy: String!) {
  createIrb(
    createIrbInput: {IRBPresentation: $IRBPresentation, dateOfIRBSubmission: $dateOfIRBSubmission, department: $department, type: $type, documents: $documents, emails: $emails, fundType: $fundType, isFunded: $isFunded, principalInvestigator: $principalInvestigator, protocolNumber: $protocolNumber, sponsor: $sponsor, studyPhase: $studyPhase, title: $title, typeOfStudy: $typeOfStudy, micr: $micr}
  ) {
    title
  }
}
    `;
export type CreateIrbSubmissionMutationFn = Apollo.MutationFunction<CreateIrbSubmissionMutation, CreateIrbSubmissionMutationVariables>;

/**
 * __useCreateIrbSubmissionMutation__
 *
 * To run a mutation, you first call `useCreateIrbSubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIrbSubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIrbSubmissionMutation, { data, loading, error }] = useCreateIrbSubmissionMutation({
 *   variables: {
 *      IRBPresentation: // value for 'IRBPresentation'
 *      dateOfIRBSubmission: // value for 'dateOfIRBSubmission'
 *      department: // value for 'department'
 *      type: // value for 'type'
 *      micr: // value for 'micr'
 *      documents: // value for 'documents'
 *      emails: // value for 'emails'
 *      fundType: // value for 'fundType'
 *      isFunded: // value for 'isFunded'
 *      principalInvestigator: // value for 'principalInvestigator'
 *      protocolNumber: // value for 'protocolNumber'
 *      sponsor: // value for 'sponsor'
 *      studyPhase: // value for 'studyPhase'
 *      title: // value for 'title'
 *      typeOfStudy: // value for 'typeOfStudy'
 *   },
 * });
 */
export function useCreateIrbSubmissionMutation(baseOptions?: Apollo.MutationHookOptions<CreateIrbSubmissionMutation, CreateIrbSubmissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateIrbSubmissionMutation, CreateIrbSubmissionMutationVariables>(CreateIrbSubmissionDocument, options);
      }
export type CreateIrbSubmissionMutationHookResult = ReturnType<typeof useCreateIrbSubmissionMutation>;
export type CreateIrbSubmissionMutationResult = Apollo.MutationResult<CreateIrbSubmissionMutation>;
export type CreateIrbSubmissionMutationOptions = Apollo.BaseMutationOptions<CreateIrbSubmissionMutation, CreateIrbSubmissionMutationVariables>;
export const UpdateIrbSubmissionDocument = gql`
    mutation updateIRBSubmission($id: String!, $department: String, $type: String, $micr: String, $dateOfIRBSubmission: DateTime!, $emails: [String!], $fundType: String, $isFunded: Boolean, $principalInvestigator: String, $protocolNumber: String, $sponsor: String, $studyPhase: String, $title: String, $typeOfStudy: String) {
  updateIrb(
    updateIrbInput: {id: $id, department: $department, type: $type, dateOfIRBSubmission: $dateOfIRBSubmission, emails: $emails, fundType: $fundType, isFunded: $isFunded, principalInvestigator: $principalInvestigator, protocolNumber: $protocolNumber, sponsor: $sponsor, studyPhase: $studyPhase, title: $title, typeOfStudy: $typeOfStudy, micr: $micr}
  ) {
    title
  }
}
    `;
export type UpdateIrbSubmissionMutationFn = Apollo.MutationFunction<UpdateIrbSubmissionMutation, UpdateIrbSubmissionMutationVariables>;

/**
 * __useUpdateIrbSubmissionMutation__
 *
 * To run a mutation, you first call `useUpdateIrbSubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIrbSubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIrbSubmissionMutation, { data, loading, error }] = useUpdateIrbSubmissionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      department: // value for 'department'
 *      type: // value for 'type'
 *      micr: // value for 'micr'
 *      dateOfIRBSubmission: // value for 'dateOfIRBSubmission'
 *      emails: // value for 'emails'
 *      fundType: // value for 'fundType'
 *      isFunded: // value for 'isFunded'
 *      principalInvestigator: // value for 'principalInvestigator'
 *      protocolNumber: // value for 'protocolNumber'
 *      sponsor: // value for 'sponsor'
 *      studyPhase: // value for 'studyPhase'
 *      title: // value for 'title'
 *      typeOfStudy: // value for 'typeOfStudy'
 *   },
 * });
 */
export function useUpdateIrbSubmissionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateIrbSubmissionMutation, UpdateIrbSubmissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateIrbSubmissionMutation, UpdateIrbSubmissionMutationVariables>(UpdateIrbSubmissionDocument, options);
      }
export type UpdateIrbSubmissionMutationHookResult = ReturnType<typeof useUpdateIrbSubmissionMutation>;
export type UpdateIrbSubmissionMutationResult = Apollo.MutationResult<UpdateIrbSubmissionMutation>;
export type UpdateIrbSubmissionMutationOptions = Apollo.BaseMutationOptions<UpdateIrbSubmissionMutation, UpdateIrbSubmissionMutationVariables>;
export const GetAllIrbSubmissionsDocument = gql`
    query GetAllIRBSubmissions($type: String!, $page: Int!, $perPage: Int!, $keyword: String!) {
  getAllIRBSubmissions(
    type: $type
    page: $page
    perPage: $perPage
    keyword: $keyword
  ) {
    irbs {
      _id
      emails
      typeOfStudy
      sponsor
      title
      dateOfIRBSubmission
      protocolNumber
      isAllDocReadAndAcknowledged
      micr
      principalInvestigator
      department
      createdAt
    }
    totalCount
  }
}
    `;

/**
 * __useGetAllIrbSubmissionsQuery__
 *
 * To run a query within a React component, call `useGetAllIrbSubmissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllIrbSubmissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllIrbSubmissionsQuery({
 *   variables: {
 *      type: // value for 'type'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      keyword: // value for 'keyword'
 *   },
 * });
 */
export function useGetAllIrbSubmissionsQuery(baseOptions: Apollo.QueryHookOptions<GetAllIrbSubmissionsQuery, GetAllIrbSubmissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllIrbSubmissionsQuery, GetAllIrbSubmissionsQueryVariables>(GetAllIrbSubmissionsDocument, options);
      }
export function useGetAllIrbSubmissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllIrbSubmissionsQuery, GetAllIrbSubmissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllIrbSubmissionsQuery, GetAllIrbSubmissionsQueryVariables>(GetAllIrbSubmissionsDocument, options);
        }
export type GetAllIrbSubmissionsQueryHookResult = ReturnType<typeof useGetAllIrbSubmissionsQuery>;
export type GetAllIrbSubmissionsLazyQueryHookResult = ReturnType<typeof useGetAllIrbSubmissionsLazyQuery>;
export type GetAllIrbSubmissionsQueryResult = Apollo.QueryResult<GetAllIrbSubmissionsQuery, GetAllIrbSubmissionsQueryVariables>;
export const GetIrbSubmissionInfoDocument = gql`
    query GetIrbSubmissionInfo($id: String!) {
  irb(id: $id) {
    IRBPresentation
    type
    dateOfIRBSubmission
    department
    micr
    emails
    fundType
    isFunded
    principalInvestigator
    protocolNumber
    sponsor
    studyPhase
    title
    typeOfStudy
    createdBy {
      name
      role
      avatar
    }
    documents {
      _id
      label
      isReadAndAcknowledged
    }
  }
}
    `;

/**
 * __useGetIrbSubmissionInfoQuery__
 *
 * To run a query within a React component, call `useGetIrbSubmissionInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIrbSubmissionInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIrbSubmissionInfoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetIrbSubmissionInfoQuery(baseOptions: Apollo.QueryHookOptions<GetIrbSubmissionInfoQuery, GetIrbSubmissionInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIrbSubmissionInfoQuery, GetIrbSubmissionInfoQueryVariables>(GetIrbSubmissionInfoDocument, options);
      }
export function useGetIrbSubmissionInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIrbSubmissionInfoQuery, GetIrbSubmissionInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIrbSubmissionInfoQuery, GetIrbSubmissionInfoQueryVariables>(GetIrbSubmissionInfoDocument, options);
        }
export type GetIrbSubmissionInfoQueryHookResult = ReturnType<typeof useGetIrbSubmissionInfoQuery>;
export type GetIrbSubmissionInfoLazyQueryHookResult = ReturnType<typeof useGetIrbSubmissionInfoLazyQuery>;
export type GetIrbSubmissionInfoQueryResult = Apollo.QueryResult<GetIrbSubmissionInfoQuery, GetIrbSubmissionInfoQueryVariables>;
export const RemoveIrbDocument = gql`
    mutation removeIrb($_id: String!) {
  removeIrb(_id: $_id) {
    _id
  }
}
    `;
export type RemoveIrbMutationFn = Apollo.MutationFunction<RemoveIrbMutation, RemoveIrbMutationVariables>;

/**
 * __useRemoveIrbMutation__
 *
 * To run a mutation, you first call `useRemoveIrbMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveIrbMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeIrbMutation, { data, loading, error }] = useRemoveIrbMutation({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useRemoveIrbMutation(baseOptions?: Apollo.MutationHookOptions<RemoveIrbMutation, RemoveIrbMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveIrbMutation, RemoveIrbMutationVariables>(RemoveIrbDocument, options);
      }
export type RemoveIrbMutationHookResult = ReturnType<typeof useRemoveIrbMutation>;
export type RemoveIrbMutationResult = Apollo.MutationResult<RemoveIrbMutation>;
export type RemoveIrbMutationOptions = Apollo.BaseMutationOptions<RemoveIrbMutation, RemoveIrbMutationVariables>;
export const GetSubmissionDropdownListDocument = gql`
    query getSubmissionDropdownList {
  getSubmissionDropdownList {
    department
    sponsor
    principalInvestigator
    coInvestigator
  }
}
    `;

/**
 * __useGetSubmissionDropdownListQuery__
 *
 * To run a query within a React component, call `useGetSubmissionDropdownListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubmissionDropdownListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubmissionDropdownListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSubmissionDropdownListQuery(baseOptions?: Apollo.QueryHookOptions<GetSubmissionDropdownListQuery, GetSubmissionDropdownListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubmissionDropdownListQuery, GetSubmissionDropdownListQueryVariables>(GetSubmissionDropdownListDocument, options);
      }
export function useGetSubmissionDropdownListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubmissionDropdownListQuery, GetSubmissionDropdownListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubmissionDropdownListQuery, GetSubmissionDropdownListQueryVariables>(GetSubmissionDropdownListDocument, options);
        }
export type GetSubmissionDropdownListQueryHookResult = ReturnType<typeof useGetSubmissionDropdownListQuery>;
export type GetSubmissionDropdownListLazyQueryHookResult = ReturnType<typeof useGetSubmissionDropdownListLazyQuery>;
export type GetSubmissionDropdownListQueryResult = Apollo.QueryResult<GetSubmissionDropdownListQuery, GetSubmissionDropdownListQueryVariables>;
export const CreateMeetingDocument = gql`
    mutation createMeeting($agenda: String!, $lastSubmissionDate: DateTime!, $meetingDate: DateTime!, $meetingId: String!, $meetingType: String!) {
  createMeeting(
    createMeetingInput: {agenda: $agenda, lastSubmissionDate: $lastSubmissionDate, meetingDate: $meetingDate, meetingId: $meetingId, meetingType: $meetingType}
  ) {
    _id
  }
}
    `;
export type CreateMeetingMutationFn = Apollo.MutationFunction<CreateMeetingMutation, CreateMeetingMutationVariables>;

/**
 * __useCreateMeetingMutation__
 *
 * To run a mutation, you first call `useCreateMeetingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMeetingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMeetingMutation, { data, loading, error }] = useCreateMeetingMutation({
 *   variables: {
 *      agenda: // value for 'agenda'
 *      lastSubmissionDate: // value for 'lastSubmissionDate'
 *      meetingDate: // value for 'meetingDate'
 *      meetingId: // value for 'meetingId'
 *      meetingType: // value for 'meetingType'
 *   },
 * });
 */
export function useCreateMeetingMutation(baseOptions?: Apollo.MutationHookOptions<CreateMeetingMutation, CreateMeetingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMeetingMutation, CreateMeetingMutationVariables>(CreateMeetingDocument, options);
      }
export type CreateMeetingMutationHookResult = ReturnType<typeof useCreateMeetingMutation>;
export type CreateMeetingMutationResult = Apollo.MutationResult<CreateMeetingMutation>;
export type CreateMeetingMutationOptions = Apollo.BaseMutationOptions<CreateMeetingMutation, CreateMeetingMutationVariables>;
export const UpdateMeetingDocument = gql`
    mutation updateMeeting($_id: String!, $agenda: String!, $lastSubmissionDate: DateTime!, $meetingDate: DateTime!, $meetingId: String!, $mom: String, $meetingType: String!, $projects: [ProjectInput!]) {
  updateMeeting(
    updateMeetingInput: {_id: $_id, agenda: $agenda, lastSubmissionDate: $lastSubmissionDate, meetingDate: $meetingDate, meetingId: $meetingId, mom: $mom, meetingType: $meetingType, projects: $projects}
  ) {
    _id
  }
}
    `;
export type UpdateMeetingMutationFn = Apollo.MutationFunction<UpdateMeetingMutation, UpdateMeetingMutationVariables>;

/**
 * __useUpdateMeetingMutation__
 *
 * To run a mutation, you first call `useUpdateMeetingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMeetingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMeetingMutation, { data, loading, error }] = useUpdateMeetingMutation({
 *   variables: {
 *      _id: // value for '_id'
 *      agenda: // value for 'agenda'
 *      lastSubmissionDate: // value for 'lastSubmissionDate'
 *      meetingDate: // value for 'meetingDate'
 *      meetingId: // value for 'meetingId'
 *      mom: // value for 'mom'
 *      meetingType: // value for 'meetingType'
 *      projects: // value for 'projects'
 *   },
 * });
 */
export function useUpdateMeetingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMeetingMutation, UpdateMeetingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMeetingMutation, UpdateMeetingMutationVariables>(UpdateMeetingDocument, options);
      }
export type UpdateMeetingMutationHookResult = ReturnType<typeof useUpdateMeetingMutation>;
export type UpdateMeetingMutationResult = Apollo.MutationResult<UpdateMeetingMutation>;
export type UpdateMeetingMutationOptions = Apollo.BaseMutationOptions<UpdateMeetingMutation, UpdateMeetingMutationVariables>;
export const GetAllMeetingsDocument = gql`
    query getAllMeetings($meetingDate: String!, $meetingType: String!, $page: Int!, $perPage: Int!) {
  getAllMeetings(
    meetingDate: $meetingDate
    meetingType: $meetingType
    page: $page
    perPage: $perPage
  ) {
    meetings {
      _id
      meetingId
      agenda
      meetingDate
      lastSubmissionDate
      meetingType
    }
    totalCount
  }
}
    `;

/**
 * __useGetAllMeetingsQuery__
 *
 * To run a query within a React component, call `useGetAllMeetingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllMeetingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllMeetingsQuery({
 *   variables: {
 *      meetingDate: // value for 'meetingDate'
 *      meetingType: // value for 'meetingType'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useGetAllMeetingsQuery(baseOptions: Apollo.QueryHookOptions<GetAllMeetingsQuery, GetAllMeetingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllMeetingsQuery, GetAllMeetingsQueryVariables>(GetAllMeetingsDocument, options);
      }
export function useGetAllMeetingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllMeetingsQuery, GetAllMeetingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllMeetingsQuery, GetAllMeetingsQueryVariables>(GetAllMeetingsDocument, options);
        }
export type GetAllMeetingsQueryHookResult = ReturnType<typeof useGetAllMeetingsQuery>;
export type GetAllMeetingsLazyQueryHookResult = ReturnType<typeof useGetAllMeetingsLazyQuery>;
export type GetAllMeetingsQueryResult = Apollo.QueryResult<GetAllMeetingsQuery, GetAllMeetingsQueryVariables>;
export const FindOneMeetingDocument = gql`
    query findOneMeeting($_id: String!) {
  findOneMeeting(_id: $_id) {
    _id
    meetingId
    agenda
    meetingDate
    lastSubmissionDate
    mom
    meetingType
    projects {
      _id {
        _id
        title
      }
      documents {
        label
        url
      }
    }
  }
}
    `;

/**
 * __useFindOneMeetingQuery__
 *
 * To run a query within a React component, call `useFindOneMeetingQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindOneMeetingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindOneMeetingQuery({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useFindOneMeetingQuery(baseOptions: Apollo.QueryHookOptions<FindOneMeetingQuery, FindOneMeetingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindOneMeetingQuery, FindOneMeetingQueryVariables>(FindOneMeetingDocument, options);
      }
export function useFindOneMeetingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindOneMeetingQuery, FindOneMeetingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindOneMeetingQuery, FindOneMeetingQueryVariables>(FindOneMeetingDocument, options);
        }
export type FindOneMeetingQueryHookResult = ReturnType<typeof useFindOneMeetingQuery>;
export type FindOneMeetingLazyQueryHookResult = ReturnType<typeof useFindOneMeetingLazyQuery>;
export type FindOneMeetingQueryResult = Apollo.QueryResult<FindOneMeetingQuery, FindOneMeetingQueryVariables>;
export const RemoveMeetingDocument = gql`
    mutation removeMeeting($_id: String!) {
  removeMeeting(_id: $_id) {
    _id
  }
}
    `;
export type RemoveMeetingMutationFn = Apollo.MutationFunction<RemoveMeetingMutation, RemoveMeetingMutationVariables>;

/**
 * __useRemoveMeetingMutation__
 *
 * To run a mutation, you first call `useRemoveMeetingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveMeetingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeMeetingMutation, { data, loading, error }] = useRemoveMeetingMutation({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useRemoveMeetingMutation(baseOptions?: Apollo.MutationHookOptions<RemoveMeetingMutation, RemoveMeetingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveMeetingMutation, RemoveMeetingMutationVariables>(RemoveMeetingDocument, options);
      }
export type RemoveMeetingMutationHookResult = ReturnType<typeof useRemoveMeetingMutation>;
export type RemoveMeetingMutationResult = Apollo.MutationResult<RemoveMeetingMutation>;
export type RemoveMeetingMutationOptions = Apollo.BaseMutationOptions<RemoveMeetingMutation, RemoveMeetingMutationVariables>;
export const GetUserByIdDocument = gql`
    query GetUserById($id: String!) {
  getUserById(_id: $id) {
    avatar
    name
    role
    email
    updatedAt
  }
}
    `;

/**
 * __useGetUserByIdQuery__
 *
 * To run a query within a React component, call `useGetUserByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserByIdQuery(baseOptions: Apollo.QueryHookOptions<GetUserByIdQuery, GetUserByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserByIdQuery, GetUserByIdQueryVariables>(GetUserByIdDocument, options);
      }
export function useGetUserByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserByIdQuery, GetUserByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserByIdQuery, GetUserByIdQueryVariables>(GetUserByIdDocument, options);
        }
export type GetUserByIdQueryHookResult = ReturnType<typeof useGetUserByIdQuery>;
export type GetUserByIdLazyQueryHookResult = ReturnType<typeof useGetUserByIdLazyQuery>;
export type GetUserByIdQueryResult = Apollo.QueryResult<GetUserByIdQuery, GetUserByIdQueryVariables>;
export const UpdateUserDocument = gql`
    mutation UpdateUser($id: String!, $avatar: String, $email: String, $name: String, $role: String) {
  updateUser(
    updateUserInput: {_id: $id, avatar: $avatar, email: $email, name: $name, role: $role}
  ) {
    avatar
    name
    role
    email
    updatedAt
  }
}
    `;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      avatar: // value for 'avatar'
 *      email: // value for 'email'
 *      name: // value for 'name'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;